import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'

import { errors, styles, translations, utils } from 'gipsy-misc'
import { user } from 'gipsy-api'
import { Icon, media } from 'gipsy-ui'
import { Header, SectionContainer } from 'pages/settings/components/common'

const prefixUrl = `https://${process.env.REACT_APP_PROFILE}.me/`
const DELAY_BEFORE_PATCH_REQUEST = 500

const propTypes = {
  user: PropTypes.object.isRequired
}

class GipsybotMe extends PureComponent {
  state = {
    saved: false,
    copiedSuccessfully: false,
    linkId: '',
    lastValidLinkId: ''
  }

  constructor(props) {
    super(props)
    this.state = { ...this.state, linkId: this.props.user.linkId, lastValidLinkId: this.props.user.linkId }
  }

  componentDidUpdate = prevProps => {
    if (prevProps.user.linkId !== this.props.user.linkId) {
      this.setState({ linkId: this.props.user.linkId, lastValidLinkId: this.props.user.linkId })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  onChange = async () => {
    const value = this.input.value
    this.setState({ linkId: value, error: undefined })

    utils.resolve.once(
      'linkId',
      () => {
        this.updateLinkId(value)
      },
      DELAY_BEFORE_PATCH_REQUEST
    )
  }

  updateLinkId = async linkId => {
    try {
      if (linkId === this.state.lastValidLinkId) {
        return
      }
      await user.patch(undefined, { linkId: linkId })
      this.setSave(linkId)
    } catch (err) {
      console.error(err)
      this.setState({ error: get(err, 'data.code') })
    }
  }

  setSave = linkId => {
    this.setState({ saved: true, lastValidLinkId: linkId, error: undefined })
    this.timeout = setTimeout(() => {
      this.setState({ saved: false })
    }, 5000)
  }

  fallbackCopyTextToClipboard = text => {
    var textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      var successful = document.execCommand('copy')
      if (successful) {
        this.setCopiedSuccessfully()
      }
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  }

  copyTextToClipboard = async text => {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text)
      return
    }
    try {
      await navigator.clipboard.writeText(text)
      this.setCopiedSuccessfully()
    } catch (err) {
      console.error('Async: Could not copy text: ', err)
    }
  }

  onClickCopy = () => {
    const text = prefixUrl + this.state.linkId
    this.copyTextToClipboard(text)
  }

  setCopiedSuccessfully = () => {
    this.setState({ copiedSuccessfully: true })
    this.timeout = setTimeout(() => {
      this.setState({ copiedSuccessfully: false })
    }, 3000)
  }

  render = () => {
    const { copiedSuccessfully, error, linkId } = this.state
    return (
      <SectionContainer>
        <Header title={translations.settings.section.gipsybotme.title} isSaved={this.state.saved} />
        <Subtitle>
          {translations.settings.section.gipsybotme.subtitle.part1}
          <br />
          {translations.settings.section.gipsybotme.subtitle.part2}
        </Subtitle>
        <LinkContainer>
          <PrefixContainer>{prefixUrl}</PrefixContainer>
          <SuffixContainer error={error}>
            <Input
              value={linkId}
              ref={ref => {
                this.input = ref
              }}
              onChange={this.onChange}
            />
            {copiedSuccessfully ? (
              <StyledIcon icon="Checked" size={14} fill={styles.colors.successColor} />
            ) : (
              <CopyContainer onClick={this.onClickCopy}>
                <StyledIcon icon="Copy" size={14} />
                <CopyTitle>{translations.settings.section.gipsybotme.copyLink}</CopyTitle>
              </CopyContainer>
            )}
          </SuffixContainer>
        </LinkContainer>
        {error && (
          <ErrorContainer>
            <Icon icon="ExclamationTriangle" size={14} fill={styles.colors.errorColor} />
            <ErrorTextContainer>{errors.gipsybotmelink[error]}</ErrorTextContainer>
          </ErrorContainer>
        )}
      </SectionContainer>
    )
  }
}

const Subtitle = styled.div`
  margin-bottom: 20px;
  font-size: ${styles.fonts.fontSizeSmall};
  color: ${styles.colors.textLightColor};
  line-height: 24px;
`

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
`

const PrefixContainer = styled.span`
  flex-shrink: 0;
`

const SuffixContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #ebeaee;

  border: ${props => props.error && `1px solid ${styles.colors.errorColor}`};
  border-radius: 8px;
  height: 40px;
  width: 100%;
  margin-left: 5px;
  padding: 5px;
`

const Input = styled.input`
  background-color: initial;
  border: none;
  font: inherit !important;
  color: ${styles.colors.textRegularColor} !important;
  width: 100%;
  font-size: ${styles.fonts.fontSizeSmall} !important;
`

const StyledIcon = styled(Icon)`
  margin-right: 5px;
`

const CopyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
`

const CopyTitle = styled.span`
  color: #86829d;
  font-size: 10px;
  font-weight: bold;
  ${media['phone-wide']`
  display:None;
`}
`

const ErrorContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const ErrorTextContainer = styled.span`
  color: ${styles.colors.errorColor};
  font-size: ${styles.fonts.fontSizeSmall};
  margin-left: 5px;
`

GipsybotMe.propTypes = propTypes

export default GipsybotMe



// WEBPACK FOOTER //
// ./src/pages/settings/components/gipsybotme/index.js